module.exports = __webpack_public_path__ + "img/business-deal.b2b74ac2.svg";